var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMortarboardFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e/icon/education/mortarboard_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 12.2816V14.0001C19 17.8661 15.8659 21.0001 12 21.0001C8.13396 21.0001 4.99995 17.8661 4.99995 14.0001V12.2816L11.3588 15.2885C11.7647 15.4804 12.2353 15.4804 12.6413 15.2885L19 12.2816ZM12.6413 2.71184L21.7216 7.00564C22.4551 7.35249 22.5479 8.30796 22 8.80876V13.0001C22 13.5524 21.5522 14.0001 21 14.0001C20.4477 14.0001 20 13.5524 20 13.0001V9.80862L12.6413 13.2883C12.2353 13.4803 11.7647 13.4803 11.3588 13.2883L2.27845 8.99449C1.43874 8.59743 1.43877 7.4027 2.27845 7.00564L11.3588 2.71184C11.7647 2.51988 12.2353 2.51988 12.6413 2.71184Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMortarboardFill);
export default __webpack_public_path__ + "static/media/mortarboard_fill.09cc2e1f8e6cd4f5cc2c49891322dfb2.svg";
export { ForwardRef as ReactComponent };